import * as React from 'react'

const ICON = `M15 1.89319C20.0016 1.89319 24.0545 5.94788 24.0545 10.9477C24.0545 14.6977 17.3267 23.867 15 28.0612C12.7693 24.0358 5.9455 14.4774 5.9455 10.9477C5.9455 5.94788 10.0002 1.89319 15 1.89319V1.89319ZM19.0471 10.6067C19.0471 8.37835 17.2295 6.56077 15 6.56077C12.7723 6.56077 10.9547 8.37835 10.9547 10.6067C10.9547 12.8344 12.7723 14.652 15 14.652C17.2295 14.652 19.0471 12.8344 19.0471 10.6067V10.6067Z`;

const pinStyle = {
  fill: '#6200EE',
  stroke: 'none'
};

function Pin(props) {
  const { height = 28, width = 24 } = props


  return (
    <svg height={height} width={width} viewBox="0 0 24 24" style={pinStyle}>
      <path d={ICON} />
    </svg>
  );
}

export default React.memo(Pin);